"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformComponentFootprint = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformComponentFootprint extends TransformObject_1.TransformObject {
    constructor(parent, data) {
        super(parent, {
            ref: data.ref,
            name: data.name,
            pads: data.pads,
            drawings: data.drawings,
            metadata: data.metadata,
            padSignals: new Map(),
        }, `${parent.deduplicationKey}::${data.ref}`, new Set());
    }
    compile() {
        this._sharedData.compiled = {
            result: {
                ref: this._sharedData.ref,
                name: this._sharedData.name,
                pads: this._sharedData.pads,
                drawings: this._sharedData.drawings,
                metadata: this._sharedData.metadata,
            },
            padSignals: this._sharedData.padSignals,
        };
        return this._sharedData.compiled;
    }
}
exports.TransformComponentFootprint = TransformComponentFootprint;
//# sourceMappingURL=TransformComponentFootprint.js.map